import { useMemo } from "react";
import { reduceSharesToAdd } from "./reduceConnectionSharesToAdd";
import { useAccount, useMembers, useTeams } from "@zapier/client";
import { ConnectionShare } from "./useFormatConnectionShares";

export function useHydratePendingConnectionShares(toAdd: ConnectionShare[]) {
  // Figure out all the pending memberIds and teamIds that are needed to be
  // displayed in the list
  const [memberIdsToAdd, teamIdsToAdd, accountIdsToAdd] = useMemo(() => {
    return reduceSharesToAdd(toAdd);
  }, [toAdd]);

  // Hydrate the members and teams that are pending to be added
  // so they can be previewed in the list
  const { members, isLoading: isMembersLoading } = useMembers({
    ids: memberIdsToAdd,
  });
  const { teams, isLoading: isTeamsLoading } = useTeams({ ids: teamIdsToAdd });
  const { account, isLoading: isAccountLoading } = useAccount({
    enabled: accountIdsToAdd.length > 0,
  });

  //   Format Share
  const hydrated = useMemo(() => {
    return toAdd.map((share) => {
      if (share.shareType === "member" && members[share.id]) {
        return {
          ...share,
          email: members[share.id].email,
          id: members[share.id].id,
          name: members[share.id].fullName,
          photoUrl: members[share.id].photoUrl,
          shareType: "member",
        };
      }
      if (share.shareType === "group" && teams[share.id]) {
        return {
          ...share,
          id: teams[share.id].id,
          memberCount: teams[share.id].memberCount,
          name: teams[share.id].name,
          photoUrl: teams[share.id].logo,
          shareType: "group",
        };
      }
      if (
        account &&
        (String(share?.id)?.includes("account_") || share.shareType === "all")
      ) {
        return {
          ...share,
          id: "all",
          name: "Everyone",
          photoUrl: account.logoUrl,
          memberCount: account.memberCount,
          shareType: "all",
        };
      }
      return share;
    });
  }, [members, teams, account, toAdd]);

  return {
    hydrated,
    isLoading: isMembersLoading || isTeamsLoading || isAccountLoading,
  };
}
